<template>
  <!-- 完善账号信息 -->
  <el-dialog
    title="完善账号信息"
    :visible.sync="dialogVisible"
    width="30%"
    destroy-on-close
    class="mobile-dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <el-form
      :model="infoForm"
      :rules="infoFormRules"
      ref="infoFormRef"
      label-width="0px"
    >
      <el-form-item label="" prop="account">
        <el-input
          v-model="infoForm.account"
          placeholder="用户名"
          :class="['searchInput', isDark ? 'darkInput' : '']"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="" prop="pwd">
        <el-input
          type="password"
          v-model="infoForm.pwd"
          placeholder="密码"
          :class="['searchInput', isDark ? 'darkInput' : '']"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm" :loading="loading"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import api from "@/api";
import util from "@/utils/utils";
import { mapActions, mapState } from "vuex";

export default {
  name: "setPwd",
  components: {},
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      setAccountPwd: api.setAccountPwd,
      loading: false,
      infoForm: {
        account: "",
        pwd: "",
      },
      infoFormRules: {
        account: [
          { required: true, message: "用户名不能为空", trigger: "blur" },
          {
            min: 3,
            message: "用户名长度不能少于3个字符",
            trigger: "blur",
          },
        ],
        pwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "密码长度在6到20个字符之间",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("comAbout", ["isDark"]),
    ...mapActions('userAbout', ['updateUserInfo']),
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    submitForm() {
      this.$refs.infoFormRef.validate((valid) => {
        if (valid) {
          this.loading = true;
          // 设置密码
          this.setAccountPwd({ ...this.infoForm })
            .then((res) => {
              this.loading = false;
              // console.log(res, "res");
              if (res.success) {
                this.$message({
                  message: `完善用户信息成功`,
                  type: "success",
                });
                this.infoForm = {};
                // 关闭模态框
                this.$emit("close");
                // 更新用户信息
                this.updateUserInfo();
              } else {
                var msgs = util.getMsgs(res);
                var errmsg = msgs.join(",");
                this.$message.error("完善用户信息失败：" + errmsg);
              }
            })
            .catch(() => {
              this.loading = false;
            });
          // 关闭模态框
          // this.$emit('close');
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@media screen and (max-width: 750px) {
  .mobile-dialog {
    max-width: 90%;
    margin: 0 auto;
    /deep/.el-dialog {
      width: 99% !important;
    }
  }
}
</style>
